import React, {useState} from 'react';
import ContactPicker from './ContactPicker';

// Title, assigned contact and due date for a CRM subtask. Used both to add a subtask and to edit one in place.
export default function SubtaskForm({ initial = {}, submitLabel = 'Add', onSubmit, onCancel }) {
  const [title, setTitle] = useState(initial.title || '');
  const [contact, setContact] = useState(initial.contact || null);
  const [dueDate, setDueDate] = useState(initial.dueDate || '');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim()) return;
    const ok = await onSubmit({ title: title.trim(), contactId: contact ? contact.id : null, contact, dueDate: dueDate || null });
    if (ok && !onCancel) { setTitle(''); setContact(null); setDueDate(''); }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-2">
      <div className="flex flex-col sm:flex-row gap-2">
        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Add a subtask..." className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600" />
        <input type="date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} aria-label="Due date" className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600" />
      </div>
      {/* ContactPicker is multi-select; keep only the most recently picked contact. */}
      <ContactPicker selected={contact ? [contact] : []} onChange={(list) => setContact(list.length > 0 ? list[list.length - 1] : null)} />
      <div className="flex justify-end gap-2">
        {onCancel && <button type="button" onClick={onCancel} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Cancel</button>}
        <button type="submit" disabled={!title.trim()} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">{submitLabel}</button>
      </div>
    </form>
  );
}
